// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__32J4Q","filesListContainer":"PosDisputesFiles_filesListContainer__3CxN1","filesButton":"PosDisputesFiles_filesButton__3w1VB"};